import { privateApi } from 'services';
import { BusinessAccountProductLicensesResponse, UpdateProductLicenseRequest } from './types';

const fetchProductLicenses = async (businessAccountId: string): Promise<BusinessAccountProductLicensesResponse> =>
    privateApi.get<BusinessAccountProductLicensesResponse>(`business-accounts/${businessAccountId}/product-licenses`);

const updateProductLicense = async (businessAccountId: string, data: UpdateProductLicenseRequest): Promise<void> =>
    privateApi.patch<void>(`business-accounts/${businessAccountId}/product-licenses`, data);

export const BusinessAccountProductLicensesGateway = {
    fetchProductLicenses,
    updateProductLicense,
};
